module.exports = __webpack_public_path__ + "img/loginIcon.fb9e9b47.png";